import React from "react";

function Services() {
  return (
    <div className="container mt-5">

      {/* TITLE */}
      <div className="text-center mb-5">
        <h1 className="fw-bold">Our Services</h1>
        <p className="text-muted w-75 mx-auto">
          We provide complete real estate and construction solutions — from
          planning and development to sales and customer support.
        </p>
      </div>

      <div className="row">

        {/* Construction */}
        <div className="col-md-4 mb-4">
          <div className="card shadow-sm h-100 text-center border-0">

            <img
              src="https://images.unsplash.com/photo-1503387762-592deb58ef4e"
              alt="construction"
              className="card-img-top"
              style={{ height: "200px", objectFit: "cover" }}
            />

            <div className="card-body">
              <h5 className="fw-semibold">Building Construction</h5>
              <p className="text-muted">
                Residential and commercial construction with modern
                architecture, high-quality materials and timely delivery.
              </p>
            </div>

          </div>
        </div>

        {/* Development */}
        <div className="col-md-4 mb-4">
          <div className="card shadow-sm h-100 text-center border-0">

            <img
              src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab"
              alt="development"
              className="card-img-top"
              style={{ height: "200px", objectFit: "cover" }}
            />

            <div className="card-body">
              <h5 className="fw-semibold">Land Development</h5>
              <p className="text-muted">
                DTCP approved layout planning, infrastructure development,
                road formation and plot structuring services.
              </p>
            </div>

          </div>
        </div>

        {/* Sales */}
        <div className="col-md-4 mb-4">
          <div className="card shadow-sm h-100 text-center border-0">

            <img
              src="https://images.unsplash.com/photo-1560518883-ce09059eeffa"
              alt="sales"
              className="card-img-top"
              style={{ height: "200px", objectFit: "cover" }}
            />

            <div className="card-body">
              <h5 className="fw-semibold">Property Sales</h5>
              <p className="text-muted">
                Support for buying and selling plots with documentation
                guidance, legal assistance and registration help.
              </p>
            </div>

          </div>
        </div>

      </div>

    </div>
  );
}

export default Services;
